import React, { ReactNode, useCallback, useMemo, useState } from 'react';

import AlertContext, { ShowAlertProps } from './Alert.context';

type AlertProviderProps = {
  children: ReactNode;
};

/**
 * Manages state and interactions for alerts
 * */
function AlertProvider({ children }: AlertProviderProps) {
  const [isVisible, setIsVisible] = useState<boolean>(true);
  const [headerText, setHeaderText] = useState<string>('');
  const [detailText, setDetailText] = useState<string>('');
  const [variant, setVariant] = useState<string>('');
  const [dismissText, setDismissText] = useState<string>('');

  /**
   * Show an alert
   */
  const showAlert = useCallback(async (props: ShowAlertProps) => {
    setIsVisible(true);
    setHeaderText(props.headerText);
    setDetailText(props.detailText);
    setVariant(props.variant);
    setDismissText(props.dismissText);
    if (props.err) {
      console.error(props.err);
    }
  }, []);

  const onDismiss = useCallback(() => {
    setIsVisible(false);
  }, []);

  const value = useMemo(
    () => ({
      onDismiss,
      showAlert,
      isVisible,
      headerText,
      detailText,
      dismissText,
      variant,
    }),
    [onDismiss, showAlert, isVisible, headerText, detailText, dismissText, variant],
  );

  return <AlertContext.Provider value={value}>{children}</AlertContext.Provider>;
}

AlertProvider.Context = AlertContext;

export default AlertProvider;
